import React from "react";

const Play = () => (
<svg width="10" height="12" viewBox="0 0 10 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.625 5.78317C8.79167 5.8794 8.79167 6.11996 8.625 6.21618L1.125 10.5463C0.958334 10.6425 0.75 10.5223 0.75 10.3298L0.750001 1.66955C0.750001 1.4771 0.958334 1.35682 1.125 1.45304L8.625 5.78317Z" stroke="#00F37A" strokeWidth="1.5"/>
</svg>
);

export default Play;
